<template>
  <div class="container-pay" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop: ${barHeight}px`">
      <van-nav-bar class="van-bar" left-trangle @click-left="goBack" @click-right="goCustomer">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.PayNext.k001') }}</span>
        </template>

        <template #right>
          <img class="icon-right" src="@/assets/packageAssets/views/P1_Boys/PayNext/default/customer.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <div class="pay">
        <div class="money-block">
          <img class="moneys" :src="getMatchImg('coin')" alt="" />
          <div class="amount">{{ myPlus(amount, presentAmount) }}</div>
        </div>
        <div class="pay-other">
          <template v-for="item in presentPropList">
            <div v-if="item.propType == 1" class="dis-item">
              <img :src="getMatchImg('chat-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 2" class="dis-item">
              <img :src="getMatchImg('video-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 4" class="dis-item">
              <img :src="getMatchImg('vip')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 6" class="dis-item">
              <img :src="getMatchImg('call-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 9" class="dis-item">
              <img :src="getMatchImg('coupon')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 15" class="dis-item">
              <img :src="getMatchImg('super-chat-pass')" />
              x{{ item.number }}
            </div>
          </template>
        </div>
      </div>

      <div class="coupons-block">
        <!-- 优惠券入口 -->
        <div :class="{ 'show-item': true, 'color-border': showCoupons }" @click="handleClickCouponEnter">
          <!-- 有可用优惠券 -->
          <template v-if="selectedCoupon">
            <div class="coupon-logo">
              <img :src="getMatchImg('coupon')" />
              <span>{{ $t('lang.BaseCommon.k038') }}</span>
            </div>

            <div class="coupon-info">
              <MyPLabel
                class="info-main"
                :str="`${$t('lang.BaseCommon.k030')} #coin# ${selectedCoupon.amount}`"
                :customClass="{ coin: 'pay-coin-icon' }"
              />
            </div>
          </template>
          <!-- 无可用优惠券 -->
          <template v-else>
            <div class="coupon-logo">
              <img :src="getMatchImg('coupon-off')" />
              <span class="no-valid-info">{{ $t('lang.BaseCommon.k064') }}</span>
            </div>
            <div class="coupon-info"></div>
          </template>
          <div class="coupon-arrow" :class="[showCoupons ? 'arrow-up' : '']"></div>
        </div>

        <!-- 优惠券列表 -->
        <div v-if="showCoupons" class="coupon-scroll">
          <div
            v-for="item in validCouponList"
            :key="item.couponRecordId"
            :class="{ 'coupon-item': true, 'coupon-acitve': selectedCoupon && item.couponRecordId === selectedCoupon.couponRecordId }"
            @click="handleSelectCoupon(item)"
          >
            <!-- 可用 -->
            <div v-if="item.canUse === true" class="coupon-con">
              <div class="coupon-info">
                <MyPLabel class="info-main" :str="item.descV2" :customClass="{ coin: 'pay-coin-icon' }" />
              </div>
            </div>
            <!-- 无用 -->
            <div v-else class="coupon-con no-valid-coupon">
              <div class="coupon-info">
                <MyPLabel class="info-main" :str="item.descV2" :customClass="{ coin: 'pay-coin-icon' }" />
              </div>
            </div>

            <div v-if="selectedCoupon && item.couponRecordId === selectedCoupon.couponRecordId" class="coupon-check checked"></div>
            <div v-else class="coupon-check not-checked"></div>
          </div>
        </div>
      </div>

      <!-- Methods -->
      <div class="block-title">
        <div>{{ $t('lang.PayNext.k004') }}</div>
      </div>

      <div v-if="googlePrice" :class="['method-item', selectedIndex === 9999 ? 'method-on' : '']" @click.prevent="selectOriginPay">
        <div class="method-check" :class="[selectedIndex === 9999 ? 'checked' : '']"></div>
        <div class="method-con">
          <div class="method-img">
            <img v-if="env.isAppIOS" src="@/assets/packageAssets/common/apple_pay.png" alt="" />
            <img v-else src="@/assets/packageAssets/common/google.png" alt="" />
          </div>
          <div class="method-name">
            <div v-if="env.isAppIOS" class="method-info">
              <span class="name">Apple Pay</span>
              <div v-if="lastUsedChannel == 'Apple Pay'" class="method-mark-container">
                <div class="method-mark last-used">{{ $t('lang.PayNext.k007') }}</div>
              </div>
            </div>

            <div v-else class="method-info">
              <span class="name">Google Pay</span>
              <div v-if="lastUsedChannel == 'Google Pay'" class="method-mark-container">
                <div class="method-mark last-used">{{ $t('lang.PayNext.k007') }}</div>
              </div>
            </div>

            <!-- 符号与金额不匹配问题-兼容 -->
            <div v-if="googleCurrencyPrice" class="rate">{{ googleCurrencyPrice }}</div>
            <div v-else class="rate">{{ googleCurrency }} {{ googlePrice }}</div>
          </div>
        </div>
      </div>

      <div
        v-for="(item, index) in payList"
        :key="index"
        :class="['method-item', item.ifBestPrice === true ? 'best-type' : '', index === selectedIndex ? 'method-on' : '']"
        @click.prevent="handleSelectPay(item, index)"
      >
        <div class="method-check" :class="[index === selectedIndex ? 'checked' : '']"></div>
        <div class="method-con">
          <div class="method-img"><img :src="item.icon | imgPath" alt="" /></div>
          <div class="method-name" v-if="item.icon">
            <div class="method-info">
              <div class="name">{{ item.name }}</div>
              <div class="method-mark-container">
                <div v-if="item.label" class="method-mark discount">{{ item.label }}</div>
                <div v-if="item.lastUsed" class="method-mark last-used">{{ $t('lang.PayNext.k007') }}</div>
              </div>
            </div>
            <div class="rate">{{ item.currency }} {{ handleDiv100(item.price) }}</div>
          </div>
        </div>
        <MyPLabel v-if="item.ifBestPrice === true" class="method-tips" :str="$t('lang.PayNext.k005')" :customClass="{ coin: 'pay-coin-icon' }" />
      </div>

      <!-- 底部栏占位用 -->
      <div style="width: 100%; height: 300px"></div>

      <div class="submit-btn-block">
        <!-- prettier-ignore -->
        <div class="submit-btn" @click="handleClickPay">
          {{ $t('lang.BaseCommon.k040') }} {{ myPlus(amount, presentAmount) }} <img :src="getMatchImg('coin')" />
          <template v-if="selectedItem">
            <template v-if="selectedItem.currencyPrice">({{selectedItem.currencyPrice}})</template>
            <template v-else>({{selectedItem.currency}}&nbsp;{{handleDiv100(selectedItem.price)}})</template>
          </template>
          <van-loading v-if="loadingShow" type="spinner" color="#ffffff" class="pay-loading" size="20px" />
        </div>
        <div :style="{ height: `${bottomBarHeight || 30}px` }"></div>
      </div>
    </div>

    <!-- 支付结果弹窗 -->
    <PayResult :showDiaC="showResultDia" :oneShow="true" :title="payResultText" />
  </div>
</template>

<script>
// 多包样式
import { pageCssVars } from '@/views/P1_Boys/PayNext/z-style-cfg.js'

import { apiFetchPayList, apiFetchShopOrder } from '@/api/imee'
import { mixin } from './base.mixin.js'

import _debounce from 'lodash/debounce'

import PayResult from '@/components/CConfirm/PayResult.vue'

function strToNum(str) {
  let result = null
  if (str) {
    // prettier-ignore
    try {
      result = str * 1
    } catch (err) {
      result = null
    }
  }
  return result
}

export default {
  mixins: [pageCssVars, mixin],
  components: { PayResult },
  data() {
    const query = this.$route.query
    return {
      // 产品信息
      gid: query.gid || null,
      productId: null,

      // 优惠信息
      amount: 0,
      presentAmount: 0,
      presentPropList: [],

      // 方式-三方
      lastUsedChannel: '',
      payList: [],
      selectedIndex: -1,
      selectedItem: null,

      // 方式-google/apple
      googlePrice: query.price || null,
      googleCurrency: query.currency || null,
      googleCurrencyPrice: query.currencyPrice || null,

      // 控制参数-提示loading
      loadingShow: false,

      // 支付方式统计
      selectChannelIndex: -1,
    }
  },
  watch: {
    googlePrice: {
      handler() {
        this.selectOriginPay()
      },
      immediate: true,
    },
  },
  methods: {
    fetchPayList() {
      if (!this.gid) {
        return
      }

      const resolvePayList = (res, fromApi) => {
        this.productId = res.productId
        this.amount = res.amount || 0
        this.presentAmount = res.presentAmount || 0
        this.presentPropList = res.presentPropListV2 || []
        this.lastUsedChannel = res.lastUsedChannel
        this.payList = res.payChannelList || []

        // 渲染缓存数据，不处理优惠券
        fromApi && this.initCoupon()

        this.sortPayType()

        // 默认支付方式
        if (!this.googlePrice) {
          this.selectedBestPayType()
          this.selectOriginPay()
        }
      }

      // 读取web localstorage缓存
      const uid = this.getUid() || 'unknown'
      const localRes = window.localStorage.getItem(`payList_${uid}_${this.gid}`)
      if (this.gid && localRes) {
        resolvePayList(JSON.parse(localRes))
      }

      apiFetchPayList({
        gid: this.gid,
        activityType: this.$route.query.activityType,
        tierId: this.$route.query.tierId || null,
        shopType: this.getShopType(),
      }).then((res) => {
        if (res && res.payChannelList) {
          // 写入web localstorage缓存
          window.localStorage.setItem(`payList_${uid}_${this.gid}`, JSON.stringify(res))

          resolvePayList(res, true)
        }
      })
    },

    queryGoogleProductListCallback(res) {
      if (res) {
        try {
          const googlePayList = JSON.parse(res)
          const targetItem = googlePayList.find((item) => {
            return this.$route.query.productId == item.productId
          })
          if (targetItem) {
            this.googlePrice = targetItem.price
            this.googleCurrency = targetItem.currencyCode
            this.googleCurrencyPrice = targetItem.currencyPrice
          }
        } catch (err) {
          console.log('try catch err:', err)
        }
      }
    },

    handleSelectPay(item, index) {
      this.selectedItem = item
      this.selectedIndex = index
    },

    handleClickPay() {
      if (this.selectedIndex > -1) {
        const tempKeys = Object.keys(this.selectedItem)
        // thirdpay
        if (tempKeys && tempKeys.length && this.selectedIndex !== 9999) {
          this.thirdPay(this.selectedItem)
        }
        // googlpay/applepay
        else {
          this.originPay()
        }
      }
    },

    thirdPay: _debounce(
      function (item) {
        let payChannelTotal = null
        if (this.payList && this.payList.length) {
          payChannelTotal = this.payList.length
        }
        let payChannelIndex = null
        if (this.selectChannelIndex != -1 && payChannelTotal !== null && payChannelTotal !== 0) {
          payChannelIndex = payChannelTotal - 1 - this.selectChannelIndex
        }
        if (this.googlePrice && this.googleCurrency && payChannelTotal !== null && payChannelIndex !== null) {
          payChannelTotal = payChannelTotal + 1
          payChannelIndex = payChannelIndex + 1
        }

        const data = {
          tierId: this.$route.query.tierId || null,
          shopType: this.$route.query.shopType || null,
          gid: this.gid,
          payType: item.payType,
          scene: this.scene,
          thirdParam: this.thirdParam,
          payChannel: item.name,
          payChannelIndex: payChannelIndex,
          payChannelTotal: payChannelTotal,
        }
        if (this.$route.query.videoChatScene) {
          data.videoChatScene = this.$route.query.videoChatScene
        }
        if (this.$route.query.activityType) {
          data.activityType = this.$route.query.activityType
        }
        if (this.selectedCoupon && this.scene != 'activity') {
          data.couponRecordId = this.selectedCoupon.couponRecordId
        }
        if (this.scene == 'activity') {
          data.shopType = 7
        }
        this.$client.addEvent('top_up', {
          Action: 'Click',
          APosition: 'payButton',
          productID: this.productId,
          goodtype: 'coin',
          from: 'cash',
          paymethod: item.name,
        })

        if (this.loadingShow === true) {
          return
        }

        this.loadingShow = true

        apiFetchShopOrder(data)
          .then((res) => {
            // 下单后刷新优惠券
            this.initCoupon()

            if (res && !res.error) {
              const openInExternalBrowser = res.credential?.openInExternalBrowser || false
              const wapUrl = res.credential?.wapUrl || ''
              // 外部浏览器打开
              if (openInExternalBrowser) {
                this.appAction('open_web_outside', `?url=${wapUrl}`)

                // 调用三方支付后，无法检测支付状态，直接关闭web
                if (['10', '18', '19', '27'].includes(this.$route.query.activityType)) {
                  this.closeWeb()
                }
              }
              // webview打开
              else {
                if (wapUrl) {
                  this.$router.push({
                    path: '/pay-code',
                    query: { url: wapUrl },
                  })
                }
              }
            }
          })
          .finally(() => {
            this.loadingShow = false
          })
      },
      2000,
      {
        leading: true,
        trailing: false,
      }
    ),

    // googlePay applePay 要客户端提供方法
    originPay() {
      // 从 h5 活动页进入，客户端不知道商品信息，不知道优惠券信息
      if (this.$route.query.useWebPay == '1') {
        const params = {
          gid: this.gid,
          productId: this.$route.query.productId || '',
          activityType: this.$route.query.activityType * 1,
          scene: this.$route.query.scene || '',
          tierId: strToNum(this.$route.query.tierId),
          shopType: this.$route.query.shopType || null,
        }

        // todo 注释原因：活动不会获取优惠券
        // if (this.maxCoupon) {
        //   params.couponRecordId = this.maxCoupon.couponRecordId
        // }

        // echo
        if (this.packageName === 'echo') {
          nativePaymentFromWeb.postMessage(JSON.stringify(params))
        }
        // 其他包
        else {
          payGoogleFromWeb.postMessage(JSON.stringify(params))
        }

        // 调用原生支付后，客户端支付完成后，web可以监听window.refresh
        // 回到上级活动页面，后续逻辑由活动页面处理
        if (['10', '18', '19', '27'].includes(this.$route.query.activityType)) {
          this.goPrevious()
        }
      }
      // 从客户端商品列表进入，客户端知道商品信息，不知道优惠券信息
      else {
        const params = {
          tierId: strToNum(this.$route.query.tierId),
          shopType: this.$route.query.shopType || null,
        }

        if (this.selectedCoupon) {
          params.couponRecordId = this.selectedCoupon.couponRecordId
        }

        // echo
        if (this.packageName === 'echo') {
          nativePayment.postMessage(JSON.stringify(params))
        }
        // 其他包
        else {
          payGoogle.postMessage(JSON.stringify(params))
        }
      }
    },

    refresh() {
      this.init()
    },

    init() {
      this.fetchPayList()
    },
  },
  created() {
    this.init()

    // 客户端回调刷新
    window.refresh = this.refresh

    // 获取客户端原生支付
    if (this.packageName === 'echo') {
      window.queryProductListCallback = this.queryGoogleProductListCallback
    }
    //
    else {
      window.queryGoogleProductListCallback = this.queryGoogleProductListCallback
    }

    if (!this.$route.query.price && this.$route.query.productId) {
      this.$client.googleProductList([this.$route.query.productId], this.packageName)
    }
  },
}
</script>
<style lang="scss" scoped>
.container-pay {
  width: 100%;
  min-height: 100vh;
  background: var(--pay-bg1, #f9f9fb);

  .custom-nav-block {
    background-color: var(--pay-bg1, #f9f9fb);

    .tit-left {
      font-family: var(--base-fontfamily, 'InterTight-Regular');
      color: var(--pay-color0, #333333);
    }

    .icon-right {
      box-sizing: content-box;
      width: 25px;
      height: 25px;
    }
  }

  .main {
    padding: 20px 16px;
  }

  .pay {
    width: 100%;
    .money-block {
      display: flex;
      align-items: center;
      justify-content: center;

      font-family: var(--base-fontfamily, 'InterTight-Regular');

      .moneys {
        width: 38px;
        height: 38px;
      }
      .amount {
        color: var(--pay-color1, #333333);
        font-family: var(--base-fontfamily, 'InterTight-Regular');
        font-size: 32px;
        font-weight: 600;
        line-height: 38px;
      }
    }
    .pay-other {
      margin-top: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 16px;

      .dis-item {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        color: var(--pay-color4, #666666);
        font-family: var(--base-fontfamily, 'InterTight-Regular');
        font-size: 15px;
        line-height: 18px;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }
    .tips-one {
      width: 343px;
      margin: 8px auto 0;

      color: var(--pay-color5, #b2b2b2);
      font-family: var(--base-fontfamily, 'InterTight-Regular');
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
    }
  }

  .block-title {
    display: flex;
    align-items: flex-start;
    margin-top: 20px;
    div {
      &:nth-child(1) {
        width: 100%;
        color: var(--pay-color6, #333333);
        font-family: var(--base-fontfamily, 'InterTight-Regular');
        font-size: 20px;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }

  .coupons-block {
    margin: 16px auto 0;
    background: var(--pay-bg2, #fefefe);
    border-radius: 8px;
    overflow: visible;
    position: relative;

    .show-item {
      position: relative;
      z-index: 2;
      padding: 12px;
      display: flex;
      align-items: center;
      border-radius: 8px;
      background: var(--pay-bg2, #fefefe);
      .coupon-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        > img {
          width: 24px;
          height: 24px;
          margin: 0 4px;
        }
        > span {
          color: var(--pay-color8, #666666);
          font-family: var(--base-fontfamily, 'InterTight-Regular');
          font-size: 15px;
          font-weight: 400;
          line-height: 22px;
        }
        span.no-valid-info {
          color: var(--pay-color9, #b2b2b2);
        }
      }

      .coupon-info {
        flex: 1;
        margin: 0 4px;
        .info-main {
          color: var(--pay-color8, #666666);
          font-family: var(--base-fontfamily, 'InterTight-Regular');
          font-size: 15px;
          font-weight: 400;
          line-height: 22px;

          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
      }

      .coupon-arrow {
        width: 24px;
        height: 24px;
        background: var(--icon-arrow) top left / 100% 100% no-repeat;
        transform: rotateZ(0deg);
        &.arrow-up {
          transform: rotateZ(180deg);
        }
      }
    }

    .coupon-scroll {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 999;
      width: 100%;
      transform: translateY(102%);
      border-radius: 8px;
      background-color: var(--pay-bg4, #ffffff);
      box-shadow: 0 4px 8px 0 rgba(79, 82, 90, 0.25);
      max-height: 190px;
      padding-bottom: 5px;
      overflow-y: auto;

      .coupon-item {
        padding: 16px;
        margin: 4px 4px 0 4px;
        display: flex;
        align-items: center;
        border-radius: 8px;
        .coupon-check {
          width: 16px;
          height: 16px;
          &.checked {
            background: var(--icon-check) top left / 100% 100% no-repeat;
          }
          &.not-checked {
            background: var(--icon-not-check) top left / 100% 100% no-repeat;
          }
        }
        .coupon-con {
          flex: 1;
          display: flex;
          align-items: center;
          padding: 0 5px;
          .coupon {
            width: 20px;
            margin: 0 4px;
          }
          .coupon-info {
            .info-main {
              color: var(--pay-color8, #666666);
              font-family: var(--base-fontfamily, 'InterTight-Regular');
              font-size: 15px;
              font-style: normal;
              font-weight: 500;
              line-height: 18px;
            }
          }
        }
        .no-valid-coupon {
          .coupon-info {
            .info-main {
              color: var(--pay-color9, #b2b2b2);
            }
          }
        }
        .coupon-arrow {
          width: 24px;
          height: 24px;
          background: var(--icon-arrow) top left / 100% 100% no-repeat;
          transform: rotateZ(0deg);
          &.arrow-up {
            transform: rotateZ(180deg);
          }
        }
      }

      .coupon-acitve {
        background: var(--pay-bg3, #f4f5f7);
      }
    }
  }

  .method-item {
    width: 100%;
    margin-top: 12px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 0 1.5px 0 transparent inset;
    background: var(--pay-bg4, #ffffff);
    position: relative;
    overflow: hidden;

    .method-tips {
      padding: 4px 10px;
      font-family: var(--base-fontfamily, 'InterTight-Regular');
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      text-align: center;
      color: var(--pay-color10, #ffffff);
    }

    .method-check {
      position: absolute;
      top: 0;
      right: 0;
      width: 28px;
      height: 28px;
      &.checked {
        background: var(--icon-check2) top left / 100% 100% no-repeat;
      }
    }

    .method-con {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 12px;

      .method-img {
        display: flex;
        justify-content: center;
        width: 44px;
        height: 44px;
        margin-right: 12px;
        border-radius: 5px;
        background: var(--pay-bg3, #f4f5f7);
        > img {
          width: 44px;
          object-fit: contain;
        }
      }
      .method-name {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .method-info {
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-direction: column;
          .name {
            color: var(--pay-color11, #333333);
            font-family: var(--base-fontfamily, 'InterTight-Regular');
            font-size: 16px;
            font-weight: 500;
            line-height: 18px;
          }
          .method-mark-container {
            margin-top: 3px;
            display: flex;
            align-items: center;
            .method-mark {
              padding: 2px 6px;
              border-radius: 2px;

              font-family: var(--base-fontfamily, 'InterTight-Regular');
              font-size: 12px;
              font-weight: 500;
              line-height: 14px;

              &:not(:first-child) {
                margin: 0 4px;
              }

              &.discount {
                background: var(--pay-bg5, #fff5eb);
                color: var(--pay-color12, #f95151);
              }

              &.last-used {
                background: var(--pay-bg8, #fff5eb);
                color: var(--pay-color15, #f95151);
              }
            }
          }
        }

        .rate {
          color: var(--pay-color13, #333333);
          font-family: var(--base-fontfamily, 'InterTight-Regular');
          font-size: 15px;
          font-weight: 500;
          line-height: 18px;
          white-space: nowrap;
        }
      }
    }
  }
  .best-type {
    .method-tips {
      background: var(--pay-bg6, #a338fc);
    }
  }
  .method-on {
    box-shadow: 0 0 0px 1.5px var(--pay-bg6, #a338fc) inset;
  }

  .submit-btn-block {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 999;
    background: var(--pay-bg7, rgba(249, 249, 251, 0.8));
    padding-top: 20px;

    .submit-btn {
      width: 335px;
      margin: auto;
      padding: 13px 20px;
      border-radius: var(--pay-radius01, 100px);
      background: var(--pay-bg6, #a338fc);
      color: var(--pay-color14, #ffffff);
      text-align: center;
      font-family: var(--base-fontfamily, 'InterTight-Regular');
      font-size: 17px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 20px;
        margin: 0 3px;
      }
    }
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
}
::v-deep .coupon-enter {
  margin-bottom: 20px;
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .container-pay .method-item .method-check {
    right: unset;
    left: 0;
  }
  .container-pay .method-item .method-con .method-img {
    margin-right: unset;
    margin-left: 12px;
  }
  .container-pay .method-item .method-check.checked {
    background: var(--icon-check3) top left / 100% 100% no-repeat;
  }
}
</style>

<style>
.pay-coin-icon {
  width: 16px;
  height: 16px;
  margin: 0 1px;
}
</style>
